import { render, staticRenderFns } from "./SelectedGroups.vue?vue&type=template&id=4c5d4078&scoped=true"
import script from "./SelectedGroups.vue?vue&type=script&lang=js"
export * from "./SelectedGroups.vue?vue&type=script&lang=js"
import style0 from "./SelectedGroups.vue?vue&type=style&index=0&id=4c5d4078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d4078",
  null
  
)

export default component.exports